/**
 * created by li si yi
 * 约稿媒体显示
 * 接收约稿ID,获取媒体列表,对外暴漏媒体IDS[id,...]
 */
import React, {Component} from 'react';
import '../EditorPublishInformation.css'
import BaseComponent from "../../../../base/BaseComponent";

export default class TargetMedia extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            mediaListInfo: [],
            mediaIds: [],
        }
    }

    componentWillMount() {
        this.getMediaList()
    }

    componentDidMount() {
    }

    getData = () => {
        return this.state.mediaList.map(item => item.id);
    };

    getDetails = () => {
        return this.state.mediaList
    };

    render() {
        const {mediaListInfo} = this.state;
        return (
            <>
                {
                    mediaListInfo && mediaListInfo.map((item, index) => {
                        return (
                            <div style={{margin: '0 10px 10px 0', width: '100%', display: 'flex'}} key={item.key}>
                                <img style={{width: 22, height: 22, marginRight: 10}}
                                     src={item.mediaLogo ? item.mediaLogo : ''}/>
                                <span title={item.mediaName ? item.mediaName : ''} style={{
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis'
                                }}>{item.mediaName ? item.mediaName : ''}</span>
                            </div>
                        )
                    })
                }
            </>
        )
    }

    // 根据id查询媒体
    getMediaList = () => {

        let params = {
            "showRef": [
                "receiverIds"
            ]
        };
        this.request({
            url: `/cm-sites-business/bd/busTask/getById/${this.urlParams.taskId}`,
            method: 'post',
            contentType: 'json',
            body: params,
            callBack: (res) => {
                let mediaList = [];
                if (res && res.medias) {
                    mediaList = res.medias;
                    // ids查媒体图标
                    mediaList.map(item => {
                        if (item.id) {
                            this.state.mediaIds.push(item.id)
                        }
                    });
                    this.getMediaListAll()

                }
                this.setState({mediaList})
            }
        })
    };
    // 获取所媒体
    getMediaListAll = () => {
        if (this.state.mediaIds && this.state.mediaIds.length) {
            let mediaListInfo = [];
            let params = {
                ids: this.state.mediaIds
            };

            this.request({
                url: '/cm-sites-pms/media/getMediaGroupByIds',
                body: params,
                callBack: (res) => {
                    if (res && res.length) {
                        res.map(item => {
                            item.mediaList && item.mediaList.map(Item => {
                                mediaListInfo.push({
                                    mediaName: Item.name ? Item.name : '',
                                    mediaLogo: Item.mediaLogo ? Item.mediaLogo : item.logoUrl ? item.logoUrl : '',
                                    key: Item.id ? Item.id : ''
                                })
                            })
                        });
                        this.setState({mediaListInfo: mediaListInfo})
                    }
                }
            })
        }
    };
}